import { render, staticRenderFns } from "./VoucherList.vue?vue&type=template&id=1abcd836&"
import script from "./VoucherList.vue?vue&type=script&lang=js&"
export * from "./VoucherList.vue?vue&type=script&lang=js&"
import style0 from "./VoucherList.vue?vue&type=style&index=0&id=1abcd836&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports